import { createContext } from "react";

import { WineClubsState, initialWineClubsState } from "./state";

export type WineClubsContextInterface = WineClubsState;

const stub = (): never => {
  throw new Error("You forgot to wrap your component in <WineClubsProvider>.");
};

const initialContext = {
  ...initialWineClubsState,
  clubOptions: [],
  changeClub: stub,
  variantOptions: [],
  changeVariant: stub,
  preferenceOptions: [],
  changePreference: stub,
  frequencyOptions: [],
  changeFrequency: stub,
  planName: "",
};

export const WineClubsContext = createContext<WineClubsContextInterface>(
  initialContext
);

export default WineClubsContext;
